var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3936 0 0 1.3936 500.0059 520.8502)",
    id: 84938
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.5632 0 0 11.5632 -127.1958 -11.687)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(133,200,8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5, -14.978)",
    d: "M 5 8.978 c -1.104 0 -2 0.896 -2 2 v 8 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -8 C 7 9.873 6.104 8.978 5 8.978 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.5632 0 0 11.5632 127.1956 -11.687)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(133,200,8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-27, -14.978)",
    d: "M 27 8.978 c -1.104 0 -2 0.896 -2 2 v 8 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -8 C 29 9.873 28.104 8.978 27 8.978 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.5632 0 0 11.5632 -0.0004 57.6922)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(133,200,8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -20.978)",
    d: "M 8 24.978 h 2 v 5 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -5 h 4 v 5 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -5 h 2 v -15 H 8 V 24.978 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.5632 0 0 11.5632 -0.0004 -132.9775)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(133,200,8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -4.4887)",
    d: "M 20.723 2.53 l 1.027 -1.779 c 0.139 -0.24 0.057 -0.545 -0.184 -0.684 c -0.238 -0.139 -0.545 -0.057 -0.683 0.184 l -1.001 1.734 C 18.732 1.345 17.41 0.978 16 0.978 c -1.409 0 -2.731 0.367 -3.882 1.008 L 11.116 0.25 c -0.139 -0.239 -0.443 -0.321 -0.684 -0.183 c -0.238 0.138 -0.32 0.443 -0.183 0.683 l 1.028 1.78 C 9.294 3.986 8 6.328 8 8.978 h 16 C 24 6.328 22.706 3.986 20.723 2.53 z M 13 5.978 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 s 1 0.447 1 1 S 13.553 5.978 13 5.978 z M 19 5.978 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 s 1 0.447 1 1 S 19.553 5.978 19 5.978 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.b89364b0c165510d9154dc139bcc3651.svg";
export { ForwardRef as ReactComponent };